import { CSSObject } from '@emotion/react'
import { AssetReference } from '@opallabs/cassini'
import getAssetOrientation from '../../helpers/functions/getAssetOrientation'
import { sharedColors } from '../sharedDisplays/sharedStyles/colors'

type AssetStyleProps = {
  height?: string
  objectFit?: string
  width?: string
}

type DisplayProps = {
  [key: string]: {
    landscape: AssetStyleProps
    portrait: AssetStyleProps
    square: AssetStyleProps
    width: number
  }
}

const renderLayout: DisplayProps = {
  desktopSingle: {
    portrait: {
      height: '568px',
    },
    landscape: {
      width: '568px',
    },
    square: {
      height: '568px',
      width: '568px',
    },
    width: 600,
  },
  mobileSingle: {
    portrait: {
      height: '343px',
      objectFit: 'cover',
      width: '343px',
    },
    landscape: {
      width: '343px',
    },
    square: {
      height: '343px',
      width: '343px',
    },
    width: 375,
  },
  desktopStream: {
    portrait: {
      height: '509px',
    },
    landscape: {
      width: '509px',
    },
    square: {
      height: '509px',
      width: '509px',
    },
    width: 600,
  },
  mobileStream: {
    portrait: {
      height: '283px',
      objectFit: 'cover',
      width: '283px',
    },
    landscape: {
      height: '160px',
      objectFit: 'cover',
      width: '283px',
    },
    square: {
      height: '283px',
      width: '283px',
    },
    width: 375,
  },
}

const baseStyles = (display: string, postType: string): CSSObject => ({
  backgroundColor: '#fff',
  border: postType === 'moment' ? sharedColors.momentBorder : 'none',
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  width:
    postType === 'moment'
      ? `calc(${renderLayout[display].width}px - 2px)`
      : renderLayout[display].width,
})

const getAssetContainerStyles = (display: string): CSSObject => ({
  borderRadius: '10px',
  margin: display.includes('Stream')
    ? '0px 16px 2px 76px'
    : '0px 16px 2px 16px',
  overflow: 'hidden',
})

const getAssetStyles = (
  asset: AssetReference,
  display: string
): { asset: CSSObject } => {
  const orientation = getAssetOrientation(asset)

  const assetStyles = renderLayout[display][orientation] as CSSObject
  const assetDisplayWidth =
    orientation === 'portrait' && display.includes('desktop')
      ? renderLayout[display][orientation].height
      : renderLayout[display][orientation].width
  return {
    asset: {
      backgroundColor: 'black',
      display: 'flex',
      justifyContent: 'center',
      width: assetDisplayWidth,
      video: {
        height: 'auto',
        marginBottom: '-1px',
        width: 'auto',
        ...assetStyles,
      },
    },
  }
}

const assetStyles = {
  baseStyles,
  getAssetContainerStyles,
  getAssetStyles,
}

export { assetStyles }
